import React from 'react';
import PropTypes from 'prop-types';
import { animatePageScroll } from './scroll';

import './FootNote.css';

const FootNote = (props) => {
  // eslint-disable-next-line react/prop-types
  const { children, i } = props;

  return(
    <li>
      <div
        id={`footnotemsg${i}`}
        onKeyPress={(event) => {
          if (event.key === 'Enter') { animatePageScroll(i, 70, `#footnoteref${i}`); }
        }}
        onClick={() => animatePageScroll(i, 70, `#footnoteref${i}`)}
        role="button"
        tabIndex="0"
      >
        <span>{`${children} `}</span>
        <span>&uarr;</span>
      </div>
    </li>
  );
};

FootNote.propTypes = {
  i: PropTypes.number
};

const FootNotes = () => (
  <div className="main-content sources-section">
    <div className="main-content--two">
      <h1 id="footnote-label" className="sr-only">Footnotes</h1>
      <ol className="page-content">
        <FootNote i={1}>Data provided by Boston Logan International Airport. </FootNote>
        <FootNote i={2}>For the purpose of this data report, Greater Boston is defined as the 46 cities and towns that touch or are contained within the Interstate 95 corridor, are north of Norwell and Scituate, and south of Danvers and Beverly. </FootNote>
        <FootNote i={3}>
          Population data to determine per person rates are from the
          <a className="footnote_link" href="https://www.census.gov/programs-surveys/acs/news/data-releases.html">2016 American Community Survey (ACS)</a>
          {' '}
          published by the U.S. Census Bureau.
          {' '}
        </FootNote>
        <FootNote i={4}>Average ride time and distance based on 99.87% of the aggregated ride share trips. </FootNote>
        <FootNote i={5}>Population density and age data are from the 2010 American Community Survey published by the U.S. Census Bureau.</FootNote>
      </ol>
    </div>
  </div>
);

export default FootNotes;
